<template>
  <div class="relative max-w-full">
    <WebccScroll
      :buttons="screen.isSmall || 'hover'"
      @items-display="handleItemsDisplay"
    >
      <HitboxRecommender
        v-for="accom in accoms"
        :key="accom.accom"
        :accom
        :currency="confData.currency"
        :language-prefix="confData.languagePrefix || ''"
        :tracker
        class="relative h-auto min-w-[18rem] max-w-[18rem] cursor-pointer snap-start overflow-hidden !pb-2"
      />
      <template #button="{ direction, scrollTo }">
        <WebccButton
          variant="white"
          :icon="`searchpage/chevron-${direction}-large`"
          round
          class="absolute top-1/3"
          :class="`${direction}-2`"
          @click="scrollTo(direction)"
        />
      </template>
    </WebccScroll>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  accoms: PreparedItem[]
  tracker?: 'recommendation' | 'handpicked'
}>()

const confData = useConfdata()
const tracking = useTracking()
const screen = useScreen()

function handleItemsDisplay(
  displayed: number[],
  appeared: number[],
  direction?: ScrollDirectionHorizontal,
) {
  if (!props.tracker) return
  if (!displayed.length) return

  if (direction) {
    tracking.handlers?.[props.tracker].scroll(direction, pickItems(appeared))
  } else {
    tracking.handlers?.[props.tracker].display(pickItems(displayed))
  }
}

function pickItems(indexes: number[]) {
  return indexes.map((index) => props.accoms[index]).filter(Boolean)
}
</script>
